import { CustomizationString } from '../../../models/customization';
import { CustomizationString as OctopusCustomizationString } from '../models/customization-string';
import { EntityMapper } from './entity';

export class CustomizationStringMapper extends EntityMapper<
  OctopusCustomizationString,
  CustomizationString
> {
  from(source: OctopusCustomizationString): CustomizationString {
    return {
      id: source.ResourceID,
      label: source.Labels[0] ?? '',
    };
  }
}
